module.exports = "//static.hsappstatic.net/enrichment-properties-lib/static-1.8865/images/data-agent-illustration.svg"